export default "__VITE_ASSET__D3II2koo__"